/* Outdoors Nordic - fast kopknapp (alla lagen; namnet ar historiskt).
   Flyttad hit fran sections/product-information.liquid. Oforandrad logik -
   bara urlyft ur sektionen sa den filen gar att redigera utan att slasa i
   storleksgranser. Laddas med defer och bara nar laget ar 'slim'.

   Slimmat lage: baren ar INTE en kopknapp. Den tar dig till variantvaljaren och
   inget annat, aven nar en storlek redan ar vald - baren visar varken variant
   eller pris, sa ett kop darifran sker utan att kunden ser vad hon kopte.

   Klicket fangas pa DOCUMENT i capture-fas, samma monster som storleksparren i
   on-variant-picker anvander, eftersom temats egen hanterare sitter pa knappen.
   Etiketten lases fran data-size-pick sa texten har EN kalla och inte behover
   dupliceras i tolv sprak har. */
/* INP (omgång 52): text skrivs i den befintliga textnoden när elementet bara har en.
   Att byta textContent tar bort och lägger till en nod, och då räknar webbläsaren om stilen
   för hela sidan (temats :has()-regler): ~100 ms per byte på mobil, mätt. Samma text syns. */
var __onTxt = window.__onTxt || (window.__onTxt = function (el, s) {
  if (!el) return;
  s = s == null ? '' : String(s);
  var f = el.firstChild;
  if (s !== '' && f && f.nodeType === 3 && !f.nextSibling) { if (f.nodeValue !== s) f.nodeValue = s; return; }
  el.textContent = s;
});
(function () {
  /* Laddas i alla lagen (V1 Full, V1 Slimmad, V2).
       - Klickfangsten och etiketten galler BARA Slimmad.
       - V2: klicket skickas till sidans kopknapp (se nedan).
       - Visningen via data-on-past och luften i botten: Slimmad och V2, som
         foljer med hela vagen ned. Full sköts av temats egen komponent
         (data-stuck) och gommer sig vid sidfoten.
       - Chattknappen lyfts ovanfor baren i alla lagen. */
  var el = document.querySelector('sticky-add-to-cart');
  if (!el) return;
  var lage = el.getAttribute('data-on-mode');
  var slim = lage === 'slim';
  /* Kompakt (v3, omgång 54) köper som V2: trycket går till sidans köpknapp. */
  var v2 = lage === 'v2' || lage === 'v3';
  var full = !slim && !v2;

  function malgrupp() {
    var g = document.querySelectorAll('.on-vp__group');
    for (var i = 0; i < g.length; i++) {
      if (g[i].querySelector('.on-vp__sizes') || g[i].querySelector('.on-vp__pills')) return g[i];
    }
    if (g[0]) return g[0];
    /* Ingen variantvaljare pa sidan: da ar det paketblocket som bar
       storleksvalet. Sikta pa dess storleksrad, annars pa hela blocket. */
    var b = document.querySelector('.on-bundle__vp-row[data-type="size"]')
         || document.querySelector('.on-bundle__vp-row')
         || document.querySelector('on-bundle');
    return b || document.querySelector('on-variant-picker');
  }

  function satEtikett() {
    var kalla = document.querySelector('[data-size-pick]');
    if (!kalla) {
      /* Utan variantvaljare: lat paketblocket ge texten. */
      var bk = document.querySelector('[data-pick-label]');
      if (!bk) return;
      var bt = bk.getAttribute('data-pick-label');
      if (!bt) return;
      var bb = el.querySelector('.sticky-add-to-cart__button');
      if (!bb) return;
      var bs = bb.querySelector('.add-to-cart-text__content > span:first-child')
            || bb.querySelector('.add-to-cart-text__content');
      if (bs && bs.textContent.trim() !== bt) { __onTxt(bs, bt); if (window.__onCtaFit) window.__onCtaFit(); }
      return;
    }
    /* Baren säger "Välj storlek" även på BOGO (Victor, omgång 41). */
    var text = kalla.getAttribute('data-size-pick');
    if (!text) return;
    var btn = el.querySelector('.sticky-add-to-cart__button');
    if (!btn) return;
    var s = btn.querySelector('.add-to-cart-text__content > span:first-child')
         || btn.querySelector('.add-to-cart-text__content');
    if (s && s.textContent.trim() !== text) { __onTxt(s, text); if (window.__onCtaFit) window.__onCtaFit(); }
  }

  /* V2: baren ar en riktig kopknapp, men den kopier INTE sjalv. Klicket skickas
     vidare till sidans egen kopknapp, sa exakt samma vag galler som nar kunden
     trycker dar: Kopboxens storleksparr (knuff till storlekarna), BOGO-sparren,
     fler par, paket och spårning. Temats egen sticky-hanterare (puppet-klick
     med flyg-till-korgen) stangs av har sa ingenting kan lagga i korgen tva
     ganger. Fangas pa window i capture-fas sa den kor fore allt annat. */
  if (v2) window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var sb = t.closest('.sticky-add-to-cart__button');
    if (!sb || !el.contains(sb)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var sek = el.closest('.shopify-section') || document;
    /* Köpboxen i läget "Fästa baren: Välj storlek" (omgång 36): baren tar kunden
       till väljaren i stället för att köpa. Väljaren eller paketet avgör själv
       (spärr, knuff, väntande läggning efter storleksvalet). */
    var kb = sek.querySelector('on-variant-picker[data-atc-text="sticky"], on-bundle[data-atc-text="sticky"]');
    if (kb && kb.stickyPick && typeof kb.onStickyClick === 'function' && kb.querySelector('.on-vp__group, [data-vp-group]')) {
      kb.onStickyClick(e);
      return;
    }
    var huvud = sek.querySelector('product-form-component button.add-to-cart-button, product-form-component [ref="addToCartButton"]');
    if (huvud) huvud.click();
  }, true);

  if (slim) document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.sticky-add-to-cart__button')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var m = malgrupp();
    if (!m) return;
    m.setAttribute('data-nudge', '');
    setTimeout(function () { m.removeAttribute('data-nudge'); }, 900);
    try { m.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { m.scrollIntoView(); }
  }, true);

  /* Visningen: baren ar framme sa fort sidans egen kopknapp rullat forbi, och
     stannar kvar hela vagen ner. Tidsstrypt scroll-lyssnare, passive, sa den
     inte kostar huvudtrad. Ingen MutationObserver - den har kostat for mycket
     har tidigare. */
  (function () {
    /* Elementet slas upp vid VARJE avlasning, det cachas inte. Temat renderar om
       kopknappsblocket nar varianten andras, och en cachad referens pekar da pa
       en frankopplad nod - vars getBoundingClientRect ger idel nollor. Da blir
       bottom 0, villkoret falskt, och baren slocknar mitt pa sidan. */
    /* Kunden har tryckt i väljaren: då gäller zonen även överst på sidan. */
    var rortValjaren = false;
    ['pointerdown', 'focusin'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (rortValjaren || !e.target || !e.target.closest) return;
        if (e.target.closest('on-variant-picker, on-bundle') && !e.target.closest('sticky-add-to-cart')) { rortValjaren = true; las(); }
      }, true);
    });

    function las() {
      var kopblock = document.querySelector('.buy-buttons-block')
                  || document.querySelector('.product-form__buttons')
                  || document.querySelector('.shopify-section .add-to-cart-button:not(.sticky-add-to-cart__button)');
      if (!kopblock) return;
      if (!full) {
        var r = kopblock.getBoundingClientRect();
        /* Förbi köpknappen räknas först när den är en bit ovanför skärmen
           (Victor, omgång 41): standard 15 % av skärmhöjden, mobil och dator
           för sig. Annars blinkar baren fram så fort knappen lämnat kanten. */
        var pct = parseFloat(el.getAttribute(window.innerWidth >= 750 ? 'data-on-past-d' : 'data-on-past-m'));
        if (isNaN(pct)) pct = 15;
        var ute = r.bottom < -(window.innerHeight * pct / 100);
        /* "När köpknappen inte syns" (omgång 34): baren är framme även INNAN
           kunden rullat fram till köpknappen, alltså när den ligger under
           skärmen. Den räknas som synlig först när den är ovanför baren. */
        if (el.getAttribute('data-on-show') !== 'past') {
          var bar = el.querySelector('.sticky-add-to-cart__bar');
          var bh = (bar && bar.offsetHeight) || 64;
          /* Omgång 43 (Victor): baren får aldrig ligga över variantväljaren. Den
             syns överst på sidan, döljs så snart väljaren närmar sig barens plats
             (40 px innan den når barens överkant) och är dold hela vägen förbi
             köpknappen, tills knappen är X % ovanför skärmen (ovan). Utan synlig
             väljare gäller köpknappen själv som förut. */
          var vp = null;
          document.querySelectorAll('on-variant-picker, on-bundle').forEach(function (n) { if (!vp && n.offsetParent && !n.closest('sticky-add-to-cart')) vp = n; });
          var vr = vp ? vp.getBoundingClientRect() : null;
          var fore = vr ? vr.top > window.innerHeight + 40
                        : r.top > window.innerHeight - bh;
          /* Överst på sidan, innan kunden rullat eller rört väljaren, syns baren
             om den högst skymmer väljarens översta kant (halva barens höjd), eller
             inte ligger över den alls i sidled (bred dator). */
          var overst = false;
          if (window.scrollY < 8 && !rortValjaren) {
            var bw = (bar && bar.offsetWidth) || window.innerWidth;
            var bl = (window.innerWidth - bw) / 2;
            var btop = window.innerHeight - bh - ((bar && parseFloat(getComputedStyle(bar).bottom)) || 0);
            overst = !vr || vr.top > btop + bh / 2 || vr.bottom < btop - 8 || vr.right < bl || vr.left > bl + bw;
          }
          ute = ute || fore || overst;
        }
        if (ute && !el.hasAttribute('data-on-past')) setTimeout(function () { if (window.__onCtaFit) window.__onCtaFit(); }, 0);
        if (ute) el.setAttribute('data-on-past', '');
        else el.removeAttribute('data-on-past');
      }
      luft();
      chatt();
    }

    function syns() {
      var bar = el.querySelector('.sticky-add-to-cart__bar');
      if (!bar) return null;
      if (full ? bar.getAttribute('data-stuck') !== 'true' : !el.hasAttribute('data-on-past')) return null;
      var cs = getComputedStyle(bar);
      if (cs.display === 'none') return null;
      return { bar: bar, cs: cs };
    }

    /* Chattknappen (appen, #outdoors-chat-widget) ligger fast i nedre hogra
       hornet. Nar baren syns och knappen skulle hamna over den, eller for nara,
       lyfts knappen och inbjudningsbubblan med `translate`; nar baren forsvinner
       gar de tillbaka. Appens kod rors inte, bara elementens inline-stil.
       INTE transform pa vardelementet: det ar 0x0 px, och en transform gor det
       till bas for de fasta barnen, sa knappen hamnade ovanfor skarmen (uppmatt).
       Lyftet raknas fran knappens EGET avstand till nederkanten (appen satter
       sjalv 88 px pa mobil) och bara om knappen ligger over baren i sidled, sa
       den star still nar den redan ar fri (t.ex. desktop, dar baren ar centrerad). */
    var chattNu = -1, chattT = null, chattVantat = false;
    function chatt() {
      /* Appen flyttar sjalv knappen (20 px -> 88 px pa mobil) nar baren syns,
         med en animation. Ett lyft raknat mitt i den blir for stort, sa sa lange
         ett lyft ligger pa raknas det om tills det stammer - normalt blir det 0
         och appens eget lage galler. Lyftet ar en reserv for de fall appen inte
         ser baren. */
      clearTimeout(chattT);
      var w = document.getElementById('outdoors-chat-widget');
      var rot = w && w.shadowRoot;
      if (!rot) return;
      var knapp = rot.querySelector('.on-chat-btn');
      if (!knapp) return;
      var lyft = 0;
      var v = el.getAttribute('data-on-pos') !== 'top' ? syns() : null;
      if (v) {
        var kr = knapp.getBoundingClientRect();
        var br = v.bar.getBoundingClientRect();
        var isidled = kr.width > 0 && kr.left < br.right && kr.right > br.left;
        if (isidled) {
          var bas = parseFloat(getComputedStyle(knapp).bottom) || 0;
          var topp = Math.ceil(v.bar.offsetHeight + (parseFloat(v.cs.bottom) || 0));
          lyft = Math.max(0, topp + 12 - bas);
        }
      }
      /* Forsta gangen ett lyft behovs: vanta ut appens egen flytt innan
         nagot rors, sa knappen inte hoppar upp och ned. */
      if (lyft > 0 && chattNu <= 0 && !chattVantat) { chattVantat = true; chattT = setTimeout(chatt, 450); return; }
      chattVantat = false;
      if (lyft > 0) chattT = setTimeout(chatt, 450);
      if (lyft === chattNu) return;
      chattNu = lyft;
      [knapp, rot.querySelector('.on-chat-invite')].forEach(function (n) {
        if (!n) return;
        n.style.transition = 'translate .3s ease';
        n.style.translate = lyft ? '0 -' + lyft + 'px' : '';
      });
    }

    var luftNu = -1;
    function luft() {
      var h = 0;
      var v = (!full && el.getAttribute('data-on-pos') !== 'top') ? syns() : null;
      if (v) h = Math.ceil(v.bar.offsetHeight + (parseFloat(v.cs.bottom) || 0));
      if (h === luftNu) return;
      luftNu = h;
      document.documentElement.style.setProperty('--on-sticky-h', h + 'px');
    }

    /* Tidsbaserad strypning, INTE requestAnimationFrame. rAF-callbacks kors
       inte nar sidan inte malas (bakgrundsflik, throttlad renderare), och da
       skulle baren fastna i fel lage. Max tio avlasningar per sekund. */
    var senast = 0, timer = null;
    function schemalagg() {
      var nu = Date.now();
      if (nu - senast > 100) { senast = nu; las(); }
      /* Alltid ett efterslag: i Full byter temat data-stuck en stund efter
         scrollen (IntersectionObserver), och chattlyftet ska folja med. */
      clearTimeout(timer);
      timer = setTimeout(function () { senast = Date.now(); las(); }, full ? 400 : 100);
    }

    window.addEventListener('scroll', schemalagg, { passive: true });
    window.addEventListener('resize', schemalagg, { passive: true });
    las();
    /* Appen lagger in chatten efter sidladdningen; ta den nar den finns. */
    setTimeout(las, 1500);
    setTimeout(las, 4000);
  })();

  /* Samma utseende som köpknappen (omgång 34): baren tar sidans köpknapps
     bakgrund, gradient och glans. Temat ritar om baren vid variantbyte, så det
     görs om efter varje variant:update. Storlek, text och pris rörs inte. */
  function spegla() {
    var bar = document.querySelector('sticky-add-to-cart');
    if (!bar || !bar.hasAttribute('data-on-same')) return;
    var sb = bar.querySelector('.sticky-add-to-cart__button');
    var sek = bar.closest('.shopify-section') || document;
    var hb = sek.querySelector('product-form-component button.add-to-cart-button, product-form-component [ref="addToCartButton"]');
    if (!sb || !hb || hb === sb) return;
    /* Omgång 49: hörnradien följer också med, om baren inte har en egen (data-on-r-own). */
    var own = sb.hasAttribute('data-on-r-own');
    ['on-cta--bg', 'on-cta--shine'].concat(own ? [] : ['on-cta--r']).forEach(function (c) { sb.classList.toggle(c, hb.classList.contains(c)); });
    ['--on-cta-bg', '--on-shine-t', '--on-shine-end'].concat(own ? [] : ['--on-cta-r']).forEach(function (v) {
      var x = hb.style.getPropertyValue(v);
      if (x) sb.style.setProperty(v, x); else sb.style.removeProperty(v);
    });
    var hs = hb.querySelector('.on-cta-shine'), ss = sb.querySelector('.on-cta-shine');
    if (hs && !ss) { var n = document.createElement('span'); n.className = 'on-cta-shine'; n.setAttribute('aria-hidden', 'true'); sb.appendChild(n); }
    else if (!hs && ss) ss.remove();
  }
  spegla();
  setTimeout(spegla, 600);
  document.addEventListener('variant:update', function () { setTimeout(spegla, 120); setTimeout(spegla, 600); });

  if (!slim) return;
  satEtikett();
  setTimeout(satEtikett, 600);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.on-variant-option')) {
      /* Variantvaljaren haver sparren och skriver tillbaka texten i flera steg,
         sa ett enda forsok racker inte - vid 120 ms hade den inte hunnit an. */
      setTimeout(satEtikett, 120);
      setTimeout(satEtikett, 450);
      setTimeout(satEtikett, 1000);
    }
  });
})();
